import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  yupWalletTransferExternalId,
  yupContributionType,
  yupUserProfileId,
  yupAmount,
  yupFiatEquivalent,
} from 'utils';

export type AssignDepositForm = {
  walletTransferExternalId: string;
  contributionType: string;
  userProfileId: string;
  amount: number;
  fiatEquivalent: number;
};

export enum AssignDepositFormFieldNames {
  walletTransferExternalId = 'walletTransferExternalId',
  contributionType = 'contributionType',
  userProfileId = 'userProfileId',
  amount = 'amount',
  fiatEquivalent = 'fiatEquivalent',
}

export enum ContributionTypeOptions {
  employerSepContribution = 'Employer SEP Contribution',
  conversion = 'Conversion',
  transfer = 'Transfer',
  rollover = 'Rollover',
  contribution = 'Contribution',
}

export const defaultContributionType = ContributionTypeOptions.transfer;

export const useAssignDepositForm = (
  contextUsers?: any[],
): UseFormReturn<AssignDepositForm> => {
  const schema = yup.object({
    walletTransferExternalId: yupWalletTransferExternalId,
    contributionType: yupContributionType,
    userProfileId: yupUserProfileId,
    amount: yupAmount,
    fiatEquivalent: yupFiatEquivalent,
  });

  const form = useForm<AssignDepositForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: yupResolver(schema),
    context: { contextUsers },
    defaultValues: {
      contributionType: defaultContributionType,
    },
  });

  return form;
};
